var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qty-btn unselectable"},[_c('div',{staticClass:"deduct-btn rango-minus",on:{"click":function($event){_vm.count--}}}),_vm._v(" "),_c('div',{staticClass:"actual-count"},[_vm._v(_vm._s(_vm.count))]),_vm._v(" "),_c('div',{staticClass:"increase-btn rango-plus",on:{"click":function($event){_vm.count++}}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a207228","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Resources/assets/js/UI/components/quantity-btn.vue
// module id = /VtS
// module chunks = 0